import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './modules/alert'
import { session } from './modules/session'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    alert: alert,
    session: session
  }
})
